export const PaymentMethod = Object.freeze({
  Cash: 'CASH',
  BankTransfer: 'BANK TRANSFER',
  Check: 'CHECK',
})
